import React from 'react';
import ResourceUtil from './ResourceUtil';
const STRINGS = {};
let CONFIG_MAP = {};

const TenantConfigUtil = {
  reversemap: {},
  add(map) {
    return new Promise((resolve) => {
      for (var key in map) {
        STRINGS[key.toLowerCase()] = map[key];
        this.stringToObj(key, map[key], CONFIG_MAP);
      }
      console.log(CONFIG_MAP);
      resolve(map);
    })
  },
  stringToObj(path,value,obj) { //https://stackoverflow.com/a/22985802/3248247
    var parts = path.split("."), part;
    while(part = parts.shift()) {
      if( typeof obj[part] != "object") obj[part] = {};
      obj = obj[part]; // update "pointer"
    }
    obj["_value"] = value;
  },
  loadTntJson(fileNameJson) {
    var self = this;
    return ResourceUtil.getJSON(fileNameJson).then(function(resp) {
      return self.add(resp);
    });
  },
  getVal(key,lang) {
    let map = CONFIG_MAP;
    if (typeof key === 'string') {
      var keys = key.split(":");


      key.split(".").map(subKey => {
        if(typeof map[subKey] === "object"){
          map = map[subKey]
        }
      });
      let str = map._value || "";
      if(lang && map[lang]){
        str = map[lang]._value || str;
      }

      // var str = STRINGS[keys[0].toLowerCase()] || "";
      let replaceCount = (str.match(/\$/g) || []).length;
      for (var i = 1; i <= replaceCount; i++) { // <= replaceCount instead of < keys.length
        str = str.replace("$" + i, keys[i] || "");
      }

      str = str ? str : key;
      if (this.reversemap) {
        this.reversemap[str] = key;
      }
      return str;
    }
    return key;
  },
  getMsg(msgKey){
    let key = msgKey.split("_").join("").toLowerCase();
    let args = msgKey.split(":");
    args.shift();
    let fullKey = `g.msg.${key.split(":")[0]}:${args.join(":")}`;
    let msg = this.getVal(fullKey);
    if(msg === fullKey) return msgKey;
    return msg;
  },
  key(str) {
    if (typeof str === 'string' && this.reversemap && this.reversemap[str]) {
      return this.reversemap[str];
    }
    return str;
  }
};

export default TenantConfigUtil;
